import React from "react"
import MyTextareaFormField from "@common-components/fields/MyTextareaFormField"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM } from "@common-constants/*"

export const NdfGroupedCommentSection = ({ helpers, validationSchema, index }: any) => {
     const isKm = helpers.values.childs[index].categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM

     return (
          <MyTextareaFormField
               formikProps={helpers}
               validationSchema={validationSchema}
               name={`childs[${index}].description`}
               label={!isKm ? <div className="required">Commentaire</div> : "Commentaire"}
               placeholder={"Commentaire..."}
               minRows={4}
               classNameLabel={"col-lg-4"}
               classNameField={"col-lg-8"}
          />
     )
}
